import { RenterDto } from '@tallo/renter';

import { ShowingDto } from './showing.interface';

export enum RescheduleRequestStatus {
  PENDING = 'Pending',
  CONFIRMED = 'Confirmed',
  DECLINED = 'Declined',
  CANCELED = 'Canceled',
  RESCHEDULED = 'Rescheduled',
  EXPIRED = 'Expired',
}

export interface RescheduleRequestDto {
  id: string;
  status: RescheduleRequestStatus;
  renter: RenterDto;
  showing: ShowingDto;
  comment: string;
  createdAt: Date;
}
